import { menuSections } from "./menuConfig";

const companyPolicies = {
  LC7: {
    hideSections: ["general"],
    hideItems: ["result-list","odds-hub"],
  },
  909: {
    hideSections: [],
    hideItems: [],
  },
  MNB: {
    hideSections: ["general"],
    hideItems: ["result-list", "user-management"],
  },
  777: {
    hideSections: ["general"],
    hideItems: ["result-list"],
  },
  ep:{
    hideSections: ["general"],
    hideItems: ["result-list","balance-transaction"],
  }
};

const aliases = {
  lc7: "LC7",
  LC7: "LC7",
  Lc7: "LC7",
  "9o9": 909,
  "Nine-O-Nine": 909,
  909: 909,
  MNB: "MNB",
  mnb: "MNB",
  Mnb: "MNB",
  777: "777",
  "Triple Seven": "777",
  ep: "ep",
  EP: "ep",
  "EP Soccer": "ep",
};

const normalizeCompanyKey = (companyKey) => {
  if (companyKey == null) return null;
  const key = String(companyKey).trim();
  if (companyPolicies[key]) return key;
  return aliases[key] ?? aliases[key.toUpperCase?.() ?? key] ?? key;
};

export const getMenuSectionsForCompany = (companyKey) => {
  const normKey = normalizeCompanyKey(companyKey);
  const policy = companyPolicies[normKey];

  if (!policy) return menuSections;

  const { hideSections = [], hideItems = [] } = policy;

  const filtered = menuSections
    .filter((section) => !hideSections.includes(section.id))
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => !hideItems.includes(item.id)),
    }))
    .filter((section) => section.items.length > 0);

  return filtered;
};

export default getMenuSectionsForCompany;

